var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBatteryPercentage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3.5H14V2H10V3.5H9.25C8.01 3.5 7 4.51 7 5.75V19.75C7 20.99 8.01 22 9.25 22H14.75C15.99 22 17 20.99 17 19.75V5.75C17 4.51 15.99 3.5 14.75 3.5ZM15.5 19.75C15.5 20.16 15.16 20.5 14.75 20.5H9.25C8.84 20.5 8.5 20.16 8.5 19.75V5.75C8.5 5.34 8.84 5 9.25 5H14.75C15.16 5 15.5 5.34 15.5 5.75V19.75Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.25V18.25C10 18.6642 10.3358 19 10.75 19H13.25C13.6642 19 14 18.6642 14 18.25V7.25C14 6.83579 13.6642 6.5 13.25 6.5H10.75C10.3358 6.5 10 6.83579 10 7.25Z",
    fill: "#49A83E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBatteryPercentage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Battery_Percentage.07bcc69c1a19d54d411bfb0b2fa22748.svg";